export default {
  //布局组件
  Layout: () => import(/* webpackChunkName: "admin" */ '@/views/layout/Layout.vue'),
  // LayoutSec: () => import(/* webpackChunkName: "admin" */ '@/views/layout/LayoutSec.vue'),

  // 首页
  Main: () => import(/* webpackChunkName: "admin" */ '@/views/main/Main.vue'),

  // 对话
  Chat: () => import(/* webpackChunkName: "admin" */ '@/views/chat/Chat.vue'),

  // 访客
  // Visitor: () => import(/* webpackChunkName: "admin" */ '@/views/visitor/Visitor.vue'),
  
  // 顾客
  Customer: () => import(/* webpackChunkName: "admin" */ '@/views/customer/Customer.vue'),

  // 菜单列表
  MenuList: () => import(/* webpackChunkName: "admin" */ '@/views/menu/MenuList.vue'),

  // 角色列表
  RoleList: () => import(/* webpackChunkName: "admin" */ '@/views/role/RoleList.vue'),

  // 企业账号列表
  EntList: () => import(/* webpackChunkName: "admin" */ '@/views/ent/EntList.vue'),

  // 客服列表
  KefuList: () => import(/* webpackChunkName: "admin" */ '@/views/kefu/KefuList.vue'),

  // 企业配置
  EntConfig: () => import(/* webpackChunkName: "admin" */ '@/views/entconfig/EntConfig.vue'),

  // 留言列表
  LeaveMsg: () => import(/* webpackChunkName: "admin" */ '@/views/leavemsg/LeaveMsg.vue'),
  
  // IP黑名单列表
  BlackList: () => import(/* webpackChunkName: "admin" */ '@/views/black/BlackList.vue'),

  // 快捷回复列表
  QuickRepList: () => import(/* webpackChunkName: "admin" */ '@/views/quickrep/QuickRepList.vue'),
}